import { useEffect } from 'react'

import { useSelector } from 'react-redux'

import initializeGoogleTag from 'common/google-tag'
import { APP, PUBLIC_APP } from 'common/metadata-constants'
import getSessionId, { clear as clearUnauthedSession } from 'common/track-events-session-id'
import { selectUserId } from 'store/user'

const GoogleAnalyticsConfiguration = () => {
  const user_id = useSelector(selectUserId)

  useEffect(() => {
    if (user_id) {
      initializeGoogleTag({
        user_app: APP,
        scoir_session_id: getSessionId(PUBLIC_APP),
        user_id,
      })
      clearUnauthedSession()
    }
  }, [user_id])

  return null
}

export default GoogleAnalyticsConfiguration
